import React from "react";
import { Icon, Image, Container, List, Segment } from "semantic-ui-react";
import { Link } from "react-router-dom";

const Footer = props => {
  return (
    <Segment inverted style={{ padding: "3em 0em" }} vertical>
      <Container textAlign="center">
        <List horizontal inverted divided link size="small">
          <List.Item as={Link} to="/">
            <Image src="/images/footer-logo.png" />
          </List.Item>
          <List.Item>
            06026, 서울시 강남구 도산대로 235 더시에나빌딩 6층 (주)데이사이드
          </List.Item>
          <List.Item>
            <Icon name="phone" size="small" />
            02-569-7990
          </List.Item>
          <List.Item>
            <Icon name="fax" size="small" />
            070-7500-1400
          </List.Item>
        </List>
      </Container>
    </Segment>
  );
};

export default Footer;
